/**
 * Validates a client-side return path (open-redirect safe).
 * Only same-app absolute paths are allowed.
 */
export function sanitizeInternalReturnPath(from: string | null | undefined): string | null {
  if (from == null || typeof from !== 'string') return null;
  const trimmed = from.trim();
  if (!trimmed.startsWith('/')) return null;
  if (trimmed.startsWith('//')) return null;
  if (trimmed.includes('://')) return null;
  if (trimmed.includes('..')) return null;
  return trimmed;
}

/** Reads `from` from the current hash URL (e.g. #/activities/id?from=%2Fcampaigns%2F…). */
export function getReturnPathFromHash(): string | null {
  const raw = window.location.hash.slice(1) || '';
  const qIdx = raw.indexOf('?');
  if (qIdx === -1) return null;
  const params = new URLSearchParams(raw.slice(qIdx + 1));
  return sanitizeInternalReturnPath(params.get('from'));
}

export function withReturnTo(path: string, returnTo: string): string {
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}from=${encodeURIComponent(returnTo)}`;
}
